import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import {adminBaseApi} from '@/settings'
import router from '../router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    let token = ''
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      token = store.getters.token
    }

    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if(response.status != 200 || res.error != 0){
      if (res.status === 401 || res.error == 401) {
        router.app.$store.dispatch('user/resetToken')
        router.app.$router.push({path:'/login'})
        return  
      } else if (res.status == 402 || res.error == 402) {
        router.app.$store.dispatch('user/resetToken')
        router.app.$router.push({path:'/login'})
        return
      }

      if (res.error !== 0) {
        Message({
          showClose: true,
          message: res.message || 'error',
          type: 'error',
          duration: 3 * 1000
        }) 
        
        return Promise.reject(res.message || 'error')
      }

      return Promise.reject(res.message || 'error')
    }
    
    return res
  },
  error => {
    Message.close()
    Message({
      showClose: true,
      message: '请求失败',
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export async function request(uri, method = 'get', param = null) {
  uri = adminBaseApi + uri
  if (method == 'get') {
    return await service.request({
      url: uri,
      method: method,
      params: param
    })  
  } else {
    let data = param
    return await service.request({
      url: uri,
      method: method,
      data
    })   
  }
}

export function port() {
  return adminBaseApi
}
